import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=30a7b173&"
import script from "./PlanDetails.vue?vue&type=script&lang=js&"
export * from "./PlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports